export const DASHBOARD_LIST_PAGE_SIZE = 5;
export const DASHBOARD_PORTFOLIO_PAGE_SIZE = 10;
export const DASHBOARD_PAYMENTS_PAGE_SIZE = 7;
export const DASHBOARD_SIGNATURES_PAGE_SIZE = 10;
export const DASHBOARD_SIGNATURES_MAX_PER_PAGE = 50;
